"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickPriceDetails = void 0;
const pick_1 = __importDefault(require("ramda/src/pick"));
const pickPriceDetails = (product) => (0, pick_1.default)(['price', 'discountedPrice', 'discountedPriceWithServicePlan', 'masterSku', 'restockDate'], product);
exports.pickPriceDetails = pickPriceDetails;
//# sourceMappingURL=utils.js.map